import { ApiService } from '@sparklayer-io/spark-dash-core/types/api';

export interface HomeApiContract {
  toggleOnboardingFlag(teamSlug: string, environment: string, flag: string): Promise<void>;
}

declare module '@sparklayer-io/spark-dash-core/context/page-context' {
  interface Apis {
    // Optional because `pages` builds its own apis without this one. Use `useHomeApi()`.
    home?: HomeApiContract;
  }
}

export class HomeApi extends ApiService implements HomeApiContract {
  public toggleOnboardingFlag(teamSlug: string, environment: string, flag: string): Promise<void> {
    return this.api.fetch<void>({
      method: 'POST',
      path: `/${teamSlug}/${environment}/toggle-onboarding-flag/${flag}`,
    });
  }
}
